import React from 'react';
import './WhyUs.css';

import { whyChooseUs } from '../../../constants';
import { Heading } from '../../../components';



const WhyUs = () => {

  return (
    <section className="custom-form whyUs">

      {/* Content Container */}
      <div className="box-container">

        <div className='content'>
          <div className='text'>

            {/* Section Heading */}
            <Heading title={whyChooseUs.heading} subTitle={whyChooseUs.sub} linear sideHeading />

            {/* Why Choose Us Paragraph */}
            <p>{whyChooseUs.content}</p>

            {/* Why Choose Us Points */}
            <div className="whyUs-points">
              {whyChooseUs.points.map((item) => (
                <li key={item.id}>
                  <div className='icon'>{item.icon}</div>
                  <div className='text'>
                    <h5>{item.title}</h5>
                    <p>{item.content}</p>
                  </div>
                </li>
              ))}
            </div>

          </div>
        </div>

      </div>

    </section>
  );
};

export default WhyUs;